// Supplier Packages Selectors

// Packages List
export const selectSupplierPackagesData = (state) =>
  state.supplierPackages?.packages?.data || [];
export const selectSupplierPackagesLoading = (state) =>
  state.supplierPackages?.packages?.loading || false;
export const selectSupplierPackagesError = (state) =>
  state.supplierPackages?.packages?.error;
export const selectSupplierPackagesTotalCount = (state) =>
  state.supplierPackages?.packages?.totalCount || 0;

// Selected Package
export const selectSupplierPackageData = (state) =>
  state.supplierPackages?.selectedPackage?.data;
export const selectSupplierPackageLoading = (state) =>
  state.supplierPackages?.selectedPackage?.loading || false;
export const selectSupplierPackageError = (state) =>
  state.supplierPackages?.selectedPackage?.error;

// Plant Capacity Options
export const selectPlantCapacityOptions = (state) =>
  state.supplierPackages?.plantCapacityOptions?.data || [];
export const selectPlantCapacityOptionsLoading = (state) =>
  state.supplierPackages?.plantCapacityOptions?.loading || false;

// Equipment Types
export const selectEquipmentTypes = (state) =>
  state.supplierPackages?.equipmentTypes?.data || [];
export const selectEquipmentTypesLoading = (state) =>
  state.supplierPackages?.equipmentTypes?.loading || false;

// Create/Update Status
export const selectCreateUpdateLoading = (state) =>
  state.supplierPackages?.createUpdate?.loading || false;
export const selectCreateUpdateSuccess = (state) =>
  state.supplierPackages?.createUpdate?.success || false;
export const selectCreateUpdateError = (state) =>
  state.supplierPackages?.createUpdate?.error;

// Delete Status
export const selectDeleteLoading = (state) =>
  state.supplierPackages?.delete?.loading || false;
export const selectDeleteSuccess = (state) =>
  state.supplierPackages?.delete?.success || false;
export const selectDeleteError = (state) =>
  state.supplierPackages?.delete?.error;
